<span class="stat" [class.is-zero]="value() === '0'">
    <div class="ft-count count">{{ value() }}</div>
    <div class="ft-count-label" [innerHTML]="label()"></div>
</span>
